import { useQuery } from "@apollo/react-hooks";
import { WithStyles } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import { gql } from "apollo-boost";
import classNames from "classnames";
import React from "react";
import {
  Calendar,
  Globe,
  LogIn,
  LogOut,
  MessageSquare,
  User
} from "react-feather";

import styles from "../App/styles";
import ExternalNavigationItem from "./ExternalItem";
import NavigationItem from "./Item";

const Navigation: React.FunctionComponent<WithStyles<typeof styles> & {
  open: boolean;
  handleClose: () => void;
}> = ({ classes, open, handleClose }) => {
  const { loading, error, data } = useQuery(gql`
    query RedirectUrl {
      redirectUrl {
        url
      }
    }
  `);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error :(</div>;
  }

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classNames(
          classes.drawerPaper,
          !open && classes.drawerPaperClose
        )
      }}
      open={open}
    >
      <List className={classes.list}>
        <NavigationItem
          to="/planets"
          label="Planets"
          onClick={handleClose}
          button={false}
        >
          <Globe />
        </NavigationItem>
        <NavigationItem
          to="/account"
          label="Account"
          onClick={handleClose}
          button={false}
        >
          <User />
        </NavigationItem>
        <NavigationItem
          to="/calendar"
          label="Calendar"
          onClick={handleClose}
          button={false}
        >
          <Calendar />
        </NavigationItem>
        <NavigationItem
          to="/discord"
          label="Discord"
          onClick={handleClose}
          button={false}
        >
          <MessageSquare />
        </NavigationItem>
        <ExternalNavigationItem
          href={data.redirectUrl.url}
          label="Log In"
          onClick={handleClose}
          button={false}
        >
          <LogIn />
        </ExternalNavigationItem>
        <NavigationItem
          to="/logout"
          label="Log Out"
          onClick={handleClose}
          button={false}
        >
          <LogOut />
        </NavigationItem>
      </List>
    </Drawer>
  );
};

export default Navigation;
